

export class SolicitudPasajeroDTO {
  id: any;
  solicitudId: any;
  // solicitud: Solicitud;
  vcPrimerNombre: any;
  vcSegundoNombre: any;
  vcPrimerApellido: any;
  vcSegundoApellido: any;
  vcCedula: any;
  vcTelefono: any;
  vcCorreoElectronico: any;
  bEsResponsableServicio: any;
}